module.exports = __webpack_public_path__ + "media/images/expert4-754db7211a91811195d362fe082c26bb651dcf178f2b3cd11f7073b04a5c21a7.jpg";